import { AdresseDTO } from "../interfaces/adresse";
import { AdressevaelgerAdresse } from "../interfaces/adressevaelger";
import { Adresse, Maybe } from "../interfaces/schema";

function getAdresselinie1(adresse: AdressevaelgerAdresse) {
  const { etagebetegnelse, doerbetegnelse, husnummer } = adresse;
  const { vejnavn, husnummertekst } = husnummer;
  let response = vejnavn;
  if (husnummertekst) response += " " + husnummertekst;
  if (etagebetegnelse) response += ", " + etagebetegnelse + ".";
  if (doerbetegnelse) response += " " + doerbetegnelse;
  return response;
}

export const adressevaelgerToAdresseDTO = (
  adresse: AdressevaelgerAdresse,
  co?: string,
): AdresseDTO => {
  return {
    darAdresseId: adresse.id_lokalid,
    adresselinie1: getAdresselinie1(adresse),
    adresselinie2: null,
    adresselinie4: null,
    coNavn: co ? co : null,
    landekode: "DK",
    bynavn: adresse.husnummer.postnummer.navn,
    postnummer: adresse.husnummer.postnummer.postnr,
  };
};

export const beliggenhedsadresseToLine = (
  beliggenhedsadresse: Maybe<Adresse> | undefined,
) => {
  if (beliggenhedsadresse) {
    const { adresselinie1, bynavn, landekode, postnummer } =
      beliggenhedsadresse;
    return `${adresselinie1}, ${postnummer} ${bynavn} ${
      landekode !== "DK" ? landekode : ""
    }`;
  }
  return "";
};

export function AdresseDTOToString(adresse: AdresseDTO) {
  return `${adresse.adresselinie1}, ${adresse.postnummer} ${adresse.bynavn}`;
}
